import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
export class EtocSuccess extends Component {
    displayName = EtocSuccess.name

    render() {
        const meta = {
            title: "Kluwer Law Online - Etoc"
        }

        return (
            <DocumentMeta {...meta}>
            <div className="col-12">
                <div className="row">
                    <div className="col-lg-9">
                        <p className="TitlePadding Title"> Table of contents alert (ETOC)</p>
                        <p className="TitlePadding BookBody">You have successfully subscribed to the automatic table of contents (Etoc).</p>
                        <p className="TitlePadding BookBody">With each update you will receive an email with the table of contents of the updated material in your inbox.</p>
                        <p className="TitlePadding BookBody">When you do not want to receive the table of contents any longer, just press "unsubscribe" in the alert.</p>

                    </div>
                </div>
            </div >
                </DocumentMeta>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ETOC Accounts/EtocSuccess.jsx